module.exports = __webpack_public_path__ + "img/media.96509f9e.jpg";